import * as React from 'react'
import { useCoachDashboard } from '../CoachDashboardProvider'
import { FollowUpModal, IgnoreTaskModal } from '../FollowUpModals'

export function PastDueTaskCell({ row }) {
  const url = row.original.service_request_url
  const task = row.original.coach_next_task

  if (task === 'Send Follow-Up Message')
    return <FollowUpTasks row={row} task={task} />
  if (url) return <a href={url}>{task}</a>
  return task
}

function FollowUpTasks({ row, task }) {
  const { setUnfilteredDashboardData, current_user } = useCoachDashboard()
  const [followUpModalOpen, setFollowUpModalOpen] = React.useState(false)
  const [ignoreTaskModalOpen, setIgnoreTaskModalOpen] = React.useState(false)
  const serviceRequestId = row.original.service_request_id
  const updateAction = (action) => {
    const oldAction = action
    const newAction = {
      ...oldAction,
      follow_up: false,
      coach_next_task: 'Post Final Document and Close Review',
      due_at: new Date() + 3 * 24 * 60 * 60 * 1000, // 3 days from now
    }
    return newAction
  }
  const onSuccess = () => {
    setUnfilteredDashboardData((prevData) => {
      const actionToUpdate = prevData.pastDueTasks.find(
        (action) => action.service_request_id === serviceRequestId,
      )
      const newAction = updateAction(actionToUpdate)

      const newActionIsPastDue = newAction.due_at < new Date()

      const newPastDueTasks = [
        ...prevData.pastDueTasks.filter(
          (action) => action.service_request_id !== serviceRequestId,
        ),
      ]
      return {
        ...prevData,
        pastDueTasks: newActionIsPastDue
          ? [...newPastDueTasks, newAction]
          : newPastDueTasks,
      }
    })
    setFollowUpModalOpen(false)
  }

  return (
    <>
      <a className="cursor-pointer" onClick={() => setFollowUpModalOpen(true)}>
        {task}
      </a>{' '}
      |{' '}
      <a
        className="cursor-pointer"
        onClick={() => setIgnoreTaskModalOpen(true)}
      >
        Ignore
      </a>
      <FollowUpModal
        modalOpen={followUpModalOpen}
        setModalOpen={setFollowUpModalOpen}
        onSuccess={onSuccess}
        serviceRequest={row.original}
        candidateFirstName={row.original.candidate_first_name}
        coachFirstName={current_user.first_name}
      />{' '}
      <IgnoreTaskModal
        modalOpen={ignoreTaskModalOpen}
        setModalOpen={setIgnoreTaskModalOpen}
        serviceRequestId={serviceRequestId}
        url={row.original.service_request_url}
      />
    </>
  )
}
